import { render, staticRenderFns } from "./create.vue?vue&type=template&id=acf008b0&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=acf008b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf008b0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MobileCreator: require('/opt/build/repo/components/MobileCreator.vue').default,DesktopCreator: require('/opt/build/repo/components/DesktopCreator.vue').default})
